import React from "react";
const TabNavItem = ({ id, title, activeTab, setActiveTab, menuOption,setMenuOption }) => {
 
 const handleClick = () => {
   setActiveTab(id);
   setMenuOption(!menuOption);
 };
 
return (
   <li onClick={handleClick} className={activeTab === id ? "active" : ""}>
     { title }
   </li>
 );
};
export default TabNavItem;